// Skeleton placeholder. Use multiple of these inside a list/table to imply loading.
export function SkeletonRow({ widthPct = 100, heightPx = 14, className = "" }) {
    return (
        <div
            className={`skeleton ${className}`}
            style={{ width: `${widthPct}%`, height: `${heightPx}px` }}
        />
    );
}

export function SkeletonTableRows({ rows = 5, cols = 6 }) {
    return Array.from({ length: rows }).map((_, r) => (
        <tr key={r} className="border-t border-ux-border-1">
            {Array.from({ length: cols }).map((_, c) => (
                <td key={c} className="px-3 py-3">
                    <SkeletonRow widthPct={c === 0 ? 60 : 80} heightPx={12} />
                </td>
            ))}
        </tr>
    ));
}

export default SkeletonRow;
